import {cloneInstance} from "../GWDService.js";
import {ScreenComponent} from "./ScreenComponent.js";
import {notNil} from '@megaphonenpm/mputils/src/utils.js';

/**
 * Base class for components that display a value range, such as a survey bar or a dial
 * indicator.
 */
export class RangeIndicator extends ScreenComponent {
  constructor (themeID, viewInstanceID) {
    super(themeID, [viewInstanceID], {viewInstanceID: viewInstanceID});
    this.valueLabel = null;
    this.value = null;
  }

  build () {
    super.build();

    // Pre-flight check
    if (!this.valid) {
      return;
    }

    this.view = cloneInstance(this.themeID, this.viewInstanceID);
  }

  setValue (percent) {
    if (this.value !== percent) {
      this.value = percent;

      if (this.valueLabel) {
        this.valueLabel.setValue(percent);
      }
    }
  }

  setNumSegments (numSegments) {
    this.numSegments = numSegments;
  }

  /**
   * Assigns this RangeIndicator a value label in which to display the indicator's
   * current value as text. The supplied value label must be an instance of
   * InstrumentValueLabelComponent. For Guess Gauge, the value label sits above the
   * survey bar, and animates along with changes in the bar's width. Note that
   * Mood Meter's dial does not have a value label. Instead, for the sake of layout,
   * the value label in Mood Meter resides in InstrumentComponent, and is managed by
   * AnswersMoodMeterComponent.
   *
   * @param valueLabel
   */
  setValueLabel (valueLabel) {
    if (valueLabel !== this.valueLabel) {
      this.valueLabel = valueLabel;
      if (notNil(valueLabel)) {
        this.view.append(this.valueLabel.view);
      }
    }
  }

  setSize (width, height) {
    this.width = width;
    this.height = height;
    this.view.style.width = `${width}px`;
    this.view.style.height = `${height}px`;
    this.view.style.minWidth = `${width}px`;
  }
}
